/**
 * Asking for New request from anywhere — `docs/new-request.md` §13.3, §13.5.
 *
 * The sheet lives once, in `pages/office.tsx`. A record's ⋯ (*New request for
 * Dana*), a job's *Book a time* / *Book a site visit* and Activity's *To book*
 * are deep inside pages that do not hold it, so they ask with this event
 * rather than having the opener threaded through every component between.
 */
import type { NewRequestPrefill } from './new-request-sheet.js'

export const NEW_REQUEST_EVENT = 'rowted:new-request'

/** Fired after a create or a booking, so a record page on screen can refresh what it shows. */
export const REQUEST_CREATED_EVENT = 'rowted:request-created'

export function openNewRequest(prefill: NewRequestPrefill | null = null): void {
  window.dispatchEvent(new CustomEvent(NEW_REQUEST_EVENT, { detail: prefill }))
}
